import { render, staticRenderFns } from "./Allyeekee.vue?vue&type=template&id=47136808&scoped=true"
import script from "./Allyeekee.vue?vue&type=script&lang=js"
export * from "./Allyeekee.vue?vue&type=script&lang=js"
import style0 from "./Allyeekee.vue?vue&type=style&index=0&id=47136808&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47136808",
  null
  
)

export default component.exports